export default "__VITE_ASSET__07157d19__"